














import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { AspectSelectInfo } from '@/app/shared/models';
import { SerializedAspectValueDescriptor } from '@xlearn/common';


@Component
export default class AspectMenuComponent extends Vue {
  @Prop({ required: true })
  public aspect: AspectSelectInfo;

  @Prop({ required: true })
  public aspectLevel: number;

  @Prop({ required: true })
  public selectedAspect: SerializedAspectValueDescriptor | null;

  @Emit('selected')
  private emitSelected(id: string, level:number): {id:string, level:number} {
    return { id, level } ;
  }
}

